<template>
  <div class="container-wrapper">
    <div class="table-wrapper">
      <div class="flex items-center justify-between px-4 pb-3 border-b border-gray-200 dark:border-gray-600">
        <div class="font-semibold dark:text-white text-lg">Dashboard</div>
        <button
          type="button"
          @click="fetchData()"
          class="btn btn-icon btn-gray"
          :class="{ 'animate-spin': isLoading }"
        >
          <font-awesome-icon :icon="['fas', 'arrows-rotate']" />
        </button>
      </div>

      <div class="card-body">
        <!-- Stats Cards Grid -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          <!-- Card Terinput Hari Ini -->
          <div class="bg-white dark:bg-gray-800 rounded-xl p-5 shadow-sm border border-gray-100 dark:border-gray-700/50 hover:shadow-md transition-all duration-300">
            <div class="flex items-center justify-between">
              <div class="p-3 bg-emerald-50 dark:bg-emerald-900/30 rounded-xl">
                <font-awesome-icon icon="calendar-check" class="text-emerald-600 dark:text-emerald-400 text-lg" />
              </div>
              <div class="text-right">
                <span class="block text-2xl font-bold text-gray-800 dark:text-white tracking-tight">
                  {{ dataTerinput.toLocaleString() }}
                </span>
                <p class="text-xs font-semibold text-gray-400 uppercase tracking-wider mt-1">
                  Terinput Hari Ini
                </p>
              </div>
            </div>
          </div>

          <!-- Card Jumlah Relawan -->
          <div class="bg-white dark:bg-gray-800 rounded-xl p-5 shadow-sm border border-gray-100 dark:border-gray-700/50 hover:shadow-md transition-all duration-300">
            <div class="flex items-center justify-between">
              <div class="p-3 bg-amber-50 dark:bg-amber-900/30 rounded-xl">
                <font-awesome-icon icon="id-badge" class="text-amber-600 dark:text-amber-400 text-lg" />
              </div>
              <div class="text-right">
                <span class="block text-2xl font-bold text-gray-800 dark:text-white tracking-tight">
                  {{ jumlahRelawan.toLocaleString() }}
                </span>
                <p class="text-xs font-semibold text-gray-400 uppercase tracking-wider mt-1">
                  Jumlah Relawan
                </p>
              </div>
            </div>
          </div>

          <!-- Card Jumlah Target -->
          <div class="bg-white dark:bg-gray-800 rounded-xl p-5 shadow-sm border border-gray-100 dark:border-gray-700/50 hover:shadow-md transition-all duration-300">
            <div class="flex items-center justify-between">
              <div class="p-3 bg-indigo-50 dark:bg-indigo-900/30 rounded-xl">
                <font-awesome-icon icon="users" class="text-indigo-600 dark:text-indigo-400 text-lg" />
              </div>
              <div class="text-right">
                <span class="block text-2xl font-bold text-gray-800 dark:text-white tracking-tight">
                  {{ jumlahTarget.toLocaleString() }}
                </span>
                <p class="text-xs font-semibold text-gray-400 uppercase tracking-wider mt-1">
                  Jumlah Target
                </p>
              </div>
            </div>
          </div>

          <!-- Card Jumlah Pendukung -->
          <div class="bg-white dark:bg-gray-800 rounded-xl p-5 shadow-sm border border-gray-100 dark:border-gray-700/50 hover:shadow-md transition-all duration-300">
            <div class="flex items-center justify-between">
              <div class="p-3 bg-rose-50 dark:bg-rose-900/30 rounded-xl">
                <font-awesome-icon icon="handshake" class="text-rose-600 dark:text-rose-400 text-lg" />
              </div>
              <div class="text-right">
                <span class="block text-2xl font-bold text-gray-800 dark:text-white tracking-tight">
                  {{ jumlahPendukung.toLocaleString() }}
                </span>
                <p class="text-xs font-semibold text-gray-400 uppercase tracking-wider mt-1">
                  Jumlah Pendukung
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Highcharts Chart Card -->
        <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700/50">
          <div v-if="isLoading" class="flex flex-col items-center justify-center py-20 text-blue-500">
            <font-awesome-icon icon="circle-notch" class="animate-spin text-3xl mb-3" />
            <span class="text-sm font-medium dark:text-slate-300">Memuat Grafik...</span>
          </div>
          <div v-show="!isLoading">
            <div ref="barDaily" class="w-full h-96"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./dashboard-page.js"></script>